export default __webpack_public_path__ + "static/media/img_chart_grade_E.8945979d7994cd78468f5a610c14d143.svg";